export enum TransactionLimitType {
  Custom = "custom",
  Unlimited = "unlimited",
}
